// TODO: set these to your real Shopify variant IDs for the hidden Custom Basket product
const VARIANT_ID_BY_TIER = {
  Entry: 47205228708076,
  Core: 47205228740844,
  Elevated: 47205228773612,
  Statement: 47205228806380
};

function $(id){ return document.getElementById(id); }

function setStatus(msg){ $("cba-status").textContent = msg; }

async function addToCartCustomBasket({ variantId, quantity, properties }) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity, properties })
  });

  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

function toProperties(intake) {
  const props = {
    "Basket tier": intake.basket_tier,
    "Budget range": intake.budget_range,
    "Occasion": intake.occasion === "Other" ? `Other: ${intake.occasion_other || ""}`.trim() : intake.occasion,
    "Recipient type": intake.recipient_type,
    "Alcohol included": intake.alcohol_included ? "Yes" : "No",
    "Alcohol type": intake.alcohol_type,
    "Alcohol style": intake.alcohol_style || "None",
    "Dietary requirement": intake.dietary_requirement === "Other"
      ? `Other: ${intake.dietary_other || ""}`.trim()
      : intake.dietary_requirement,
    "Must avoid": (intake.must_avoid || []).join(", "),
    "Preferences notes": intake.preferences_notes || "",
    "Delivery region": intake.delivery_region,
    "ai_confidence": String(intake.confidence ?? 0)
  };

  Object.keys(props).forEach((k) => {
    if (props[k] === "" || props[k] == null) delete props[k];
  });

  return props;
}

function wire() {
  const alcohol = $("cba-alcohol");
  const alcoholType = $("cba-alcohol-type");
  alcohol?.addEventListener("change", () => {
    alcoholType.style.display = alcohol.value === "Yes" ? "block" : "none";
  });

  $("cba-submit")?.addEventListener("click", async () => {
    try {
      setStatus("Working…");

      const structured = {
        budget_range: $("cba-budget").value || undefined,
        occasion: $("cba-occasion").value || undefined,
        recipient_type: $("cba-recipient").value || undefined,
        alcohol_included: $("cba-alcohol").value === "Yes" ? true : ($("cba-alcohol").value === "No" ? false : undefined),
        alcohol_type: $("cba-alcohol-type").value || undefined,
        dietary_requirement: $("cba-dietary").value || "None",
        quantity: parseInt($("cba-qty").value || "1", 10),
        must_avoid: ($("cba-avoid").value || "").split(",").map(s => s.trim()).filter(Boolean),
        preferences_notes: $("cba-notes").value || ""
      };

      // Call your server endpoint
      const r = await fetch("https://custombasket.basketsco.com/api/cba-intake", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ structured, userText: "" })
      });

      const data = await r.json();
      if (!data.ok) throw new Error(data.message || "Intake failed");

      const intake = data.intake;
      const variantId = VARIANT_ID_BY_TIER[intake.basket_tier] || VARIANT_ID_BY_TIER.Core;
      const quantity = structured.quantity || 1;
      const properties = toProperties(intake);

      await addToCartCustomBasket({ variantId, quantity, properties });

      setStatus("Added to cart.");
      window.location.href = "/cart";
    } catch (e) {
      setStatus("Couldn't add to cart. Please try again.");
      console.error(e);
    }
  });
}

document.addEventListener("DOMContentLoaded", wire);